import { useBreakpointValue } from "@gluestack-ui/themed";
import { useCopyToClipboard } from "@repo/core/hooks/useCopyToClipboard";
import { useDeviceType } from "@repo/core/hooks/useDeviceType";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import * as Linking from "expo-linking";
export const SupportController = () => {
  const { back } = useNavigation();
  const { handleCopyToClipboard } = useCopyToClipboard();
  const { isMobile, isTablet } = useDeviceType();

  const isTabletOrWeb = useBreakpointValue({ base: false, md: true });
  const isMobileOrTablet = isMobile || isTablet;

  const handleOpenWhatsAppNumber = () => {
    if (isMobileOrTablet) {
      Linking.openURL("https://wa.me/5121122942");
    } else {
      // Only use window.open on web platform
      if (typeof window !== "undefined") {
        window.open("https://wa.me/5121122942", "_blank");
      } else {
        Linking.openURL("https://wa.me/5121122942");
      }
    }
  };
  return {
    back,
    isTabletOrWeb,
    handleOpenWhatsAppNumber,
    handleCopyToClipboard
  };
};
